// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"0e47c898","472":"a7e09c9f","672":"04f01cae","899":"30949f9d","937":"efc7d339","946":"c6bf22fe"}[chunkId] + ".chunk.js";
};